import sortingMenuscss from "./ImageSorting.module.scss"

const ImageSorting = (props) => {
  return (
    <div className={sortingMenuscss.menuBar}>
      <button
        className="option1"
        onClick={(event) => props.optionSelect(event.target.innerText)}
      >
        All
      </button>
      <button
        className="option2"
        onClick={(event) => props.optionSelect(event.target.innerText)}
      >
        Innovation Quest
      </button>
      <button
        className="optiion3"
        onClick={(event) => props.optionSelect(event.target.innerText)}
      >
        Club Orientation 2022
      </button>
    </div>
  )
}
export default ImageSorting
